import {useEffect, useRef} from 'react';

import {SKIP_TO_CONTENT_SELECTOR} from '@amblique/king-living/app/components/skip-to-content-link';

const HEADER_WRAPPER_SELECTOR = '[data-header-wrapper]';

/**
 * After pointer interaction inside the sticky header, the next Tab focuses Skip to Content.
 */
export function useHeaderTabToSkipLink() {
  const redirectNextTabRef = useRef(false);

  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const clearRedirect = () => {
      redirectNextTabRef.current = false;
    };

    const onPointerDown = (event) => {
      const headerRoot = document.querySelector(HEADER_WRAPPER_SELECTOR);

      if (!headerRoot) {
        return;
      }

      if (event.target.closest(SKIP_TO_CONTENT_SELECTOR)) {
        clearRedirect();

        return;
      }

      redirectNextTabRef.current = headerRoot.contains(event.target);
    };

    const onKeyDown = (event) => {
      if (event.key !== 'Tab' || event.shiftKey || !redirectNextTabRef.current) {
        return;
      }

      const skipLink = document.querySelector(SKIP_TO_CONTENT_SELECTOR);

      if (!skipLink) {
        return;
      }

      event.preventDefault();
      skipLink.focus({preventScroll: true});
      clearRedirect();
    };

    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('keydown', onKeyDown, true);

    return () => {
      document.removeEventListener('pointerdown', onPointerDown, true);
      document.removeEventListener('keydown', onKeyDown, true);
    };
  }, []);
}
